import { useCallback } from 'react';
import type { Dispatch, ForwardedRef, Ref, SetStateAction } from 'react';

import useAssignRef from './useAssignedRef';

type IRef<T> = Dispatch<SetStateAction<T>> | Ref<T>;

export const mergeRefs =
  <T>(...refs: Array<IRef<T> | undefined>) =>
  (node: T) => {
    refs.forEach(ref => {
      if (ref) useAssignRef(ref as ForwardedRef<T>, node);
    });
  };

export const useMergedRef = <T>(...refs: Array<IRef<T> | undefined>) =>
  useCallback((node: T) => mergeRefs(...refs)(node), [refs]);
